import { createStore } from "vuex";

export default createStore({
  state: {
    resetTrigger: false,
  },
  mutations: {
    triggerReset(state) {
      state.resetTrigger = !state.resetTrigger;
    },
  },
});